import { createBrowserRouter } from 'react-router-dom';
import { Shell } from './components/layout/Shell';
import { MinimalShell } from './components/layout/MinimalShell';
import { Home } from './routes/Home';
import { About } from './routes/About';
import { BlogIndex } from './routes/BlogIndex';
import { BlogPost } from './routes/BlogPost';
import { QuizLanding } from './routes/quiz/QuizLanding';
import { QuizPlay } from './routes/quiz/QuizPlay';
import { QuizLocked } from './routes/quiz/QuizLocked';
import { Privacy } from './routes/Privacy';
import { Terms } from './routes/Terms';
import { IosPrivacy } from './routes/legal/IosPrivacy';
import { IosTerms } from './routes/legal/IosTerms';
import { AndroidPrivacy } from './routes/legal/AndroidPrivacy';
import { AndroidTerms } from './routes/legal/AndroidTerms';
import { AppTerms } from './routes/legal/AppTerms';
import { AppPrivacy } from './routes/legal/AppPrivacy';
import { Cookies } from './routes/Cookies';
import { Contact } from './routes/Contact';
import { Download } from './routes/Download';
import { GetApp } from './routes/GetApp';
import { AuthGuard } from './components/partners/AuthGuard';
import { PartnerLayout } from './components/partners/PartnerLayout';
import { PartnerSignup } from './routes/partners/Signup';
import { PartnerLogin } from './routes/partners/Login';
import { PartnerForgotPassword } from './routes/partners/ForgotPassword';
import { PartnerDashboard } from './routes/partners/Dashboard';
import { PartnerEarnings } from './routes/partners/Earnings';
import { PartnerCampaigns } from './routes/partners/Campaigns';
import { PartnerFAQ } from './routes/partners/FAQ';
import { AdminAnalytics } from './routes/partners/AdminAnalytics';

export const router = createBrowserRouter([
  {
    element: <Shell />,
    children: [
      { path: '/', element: <Home /> },
      { path: '/about', element: <About /> },
      { path: '/blog', element: <BlogIndex /> },
      { path: '/blog/:slug', element: <BlogPost /> },
      { path: '/quiz', element: <QuizLanding /> },
      { path: '/quiz/:quizId', element: <QuizPlay /> },
      { path: '/quiz/:quizId/locked', element: <QuizLocked /> },
      { path: '/privacy', element: <Privacy /> },
      { path: '/terms', element: <Terms /> },
      { path: '/cookies', element: <Cookies /> },
      { path: '/contact', element: <Contact /> },
      { path: '/download', element: <Download /> },
    ],
  },
  {
    element: <MinimalShell />,
    children: [
      { path: '/get', element: <GetApp /> },
      { path: '/app/terms', element: <AppTerms /> },
      { path: '/app/privacy', element: <AppPrivacy /> },
      { path: '/ios/privacy', element: <IosPrivacy /> },
      { path: '/ios/terms', element: <IosTerms /> },
      { path: '/android/privacy', element: <AndroidPrivacy /> },
      { path: '/android/terms', element: <AndroidTerms /> },
    ],
  },
  // Partner portal (separate layout, no marketing shell)
  { path: '/partners/signup', element: <PartnerSignup /> },
  { path: '/partners/login', element: <PartnerLogin /> },
  { path: '/partners/forgot-password', element: <PartnerForgotPassword /> },
  {
    element: <AuthGuard />,
    children: [
      {
        element: <PartnerLayout />,
        children: [
          { path: '/partners/dashboard', element: <PartnerDashboard /> },
          { path: '/partners/earnings', element: <PartnerEarnings /> },
          { path: '/partners/campaigns', element: <PartnerCampaigns /> },
          { path: '/partners/faq', element: <PartnerFAQ /> },
          { path: '/partners/admin', element: <AdminAnalytics /> },
        ],
      },
    ],
  },
]);
